export const ModuleContext = {
  WindowContext: [{
    version: '21.9.0',
    date: '（2026-09-10）',
    desc: '截图搭载问AI，图片内容即刻问',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/pc_guide_v21_9/index.html?type=site'
  },{
    version: '21.8.0',
    date: '（2026-09-01）',
    desc: '标签页PC端互通，云同步更易找',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/pc_guide_v21_8/index.html?type=site'
  },{
    version: '21.7.0',
    date: '（2026-08-13）',
    desc: '图片查看器重磅上线，AI全能修图',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/pc_guide_v21_7/index.html?type=site'
  },{
    version: '21.6.0',
    date: '（2026-08-03）',
    desc: '书签收藏体验升级，管理书签更丝滑',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/pc_guide_v21_6/index.html?type=site'
  },{
    version: '21.5.0',
    date: '（2026-07-15）',
    desc: '元宝助手右键，支持收起为功能按钮',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/pc_guide_v21_5/index.html?type=site'
  },{
    version: '21.3.0',
    date: '（2026-06-17）',
    desc: '截图能力重构，更丝滑的截图体验',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/pc_guide_v21_3/index.html?type=site'
  },{
    version: '21.2.0',
    date: '（2026-06-08）',
    desc: '138内核代际跨越，安全防护升级',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/pc_guide_v21_2/index.html?type=site'
  },{
    version: '21.1.5',
    date: '（2026-05-13）',
    desc: '个人中心升级，支持修改头像与昵称',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v21_1_5/index.html?type=site'
  },{
    version: '21.1.0',
    date: '（2026-04-29）',
    desc: '桌面整理大师上线，AI快速整文件',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v21_1/index.html?type=site'
  },{
    version: '21.0.5',
    date: '（2026-03-26）',
    desc: '菜单新增云盘，容量一目了然',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v21_0_5/index.html?type=site'
  },{
    version: '21.0.0',
    date: '（2026-3-18）',
    desc: '深浅模式新升级，个性化调节更护眼',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v21_0/index.html?type=site'
  },{
    version: '20.1.5',
    date: '（2026-02-27）',
    desc: 'AI生PPT，文件直引一键生成',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v20_1_5/?type=site',
  },{
    version: '20.1.0',
    date: '（2026-01-29）',
    desc: 'AI新首页，学习办公新起点',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v20_1/?type=site',
  },{
    version: '20.0.0',
    date: '（2026-01-05）',
    desc: '画中画焕新，全能窗口随心控',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v20_0/?type=site',
  },{
    version: '19.9.0',
    date: '（2025-12-05）',
    desc: '万能打开升级，支持更多格式',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_9/?type=site',
  },{
    version: '19.8.5',
    date: '（2025-11-19）',
    desc: '新增AI听，双模式随心控',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_8_5/?type=site',
  },{
    version: '19.8.0',
    date: '（2025-11-05）',
    desc: 'AI+上线，全能AI助手',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_8/?type=site',
  },{
    version: '19.7.5',
    date: '（2025-10-17）',
    desc: '「较真AI」打造事实',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_7_5/?type=site',
  },
  {
    version: '19.7.0',
    date: '（2025-9-30）',
    desc: '标签页智能分组',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_7/?type=site',
  },
  {
    version: '19.6.5',
    date: '（2025-9-09）',
    desc: 'AI字幕声音即刻 “显形”',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_6_5/?type=site',
  },
  {
    version: '19.5.5',
    date: '（2025-8-08）',
    desc: '书签栏按钮文案及状态优化',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_5_5/?type=site',
  },
  {
    version: '19.4.0',
    date: '（2025-7-03）',
    desc: 'AI探索支持创建、收藏指令',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_4/?type=site',
  },
  {
    version: '19.3.5',
    date: '（2025-6-24）',
    desc: 'QBot对话支持全屏',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_3_5/?type=site',
  },
  {
    version: '19.3.0',
    date: '（2025-5-30）',
    desc: 'AI指令一键调用',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_3/?type=site',
  },
  {
    version: '19.2.5',
    date: '（2025-05-26）',
    desc: '新增相似网页推荐功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_2_5/?type=site',
  },
  {
    version: '19.2.0',
    date: '（2025-05-18）',
    desc: '常用书签实时同步',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_2/?type=site',
  },
  {
    version: '19.1.3',
    date: '（2025-04-30）',
    desc: '脑图体验优化',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_1_3/?type=site',
  }, {
    version: '19.1.2',
    date: '（2025-04-23）',
    desc: '新增阅读工具箱',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_1_2/?type=site',
  }, {
    version: '19.1.1',
    date: '（2025-04-18）',
    desc: '网页解读支持切换DeepSeek模型',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_1_1/?type=site',
  }, {
    version: '19.1.0',
    date: '（2025-04-17）',
    desc: '地址栏搜索引擎随心切换',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_1/?type=site',
  },
  {
    version: '19.0.0',
    date: '（2025-03-28）',
    desc: '全新上线QQ浏览器·QBot',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v19_0/?type=site',
  },
  {
    version: '13.7.0',
    date: '（2025-3-12）',
    desc: '桌面侧边栏 操作更快捷',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_7/?type=site',
  },
  {
    version: '13.6.0',
    date: '（2025-2-18）',
    desc: 'DeepSeek模型上线',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_6/',
  },
  {
    version: '13.5.0',
    date: '（2025-1-15）',
    desc: '管家防护和压缩包工具上线',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_5/',
  },
  {
    version: '13.4.0',
    date: '（2024-12-16）',
    desc: '消息中心和多站点搜索上线',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_4/?type=site',
  },
  {
    version: '13.3.0',
    date: '（2024-11-12）',
    desc: '阅读小窗和手机模式升级',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_3/',
  },
  {
    version: '13.2.0',
    date: '（2024-10-15）',
    desc: 'word文档引擎大上新',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_2/',
  },
  {
    version: '13.1.0',
    date: '（2024-09-20）',
    desc: '新增跨端传输',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_1/',
  },
  {
    version: '13.0.0',
    date: '（2024-08-15）',
    desc: '升级新内核，扩充直达快链',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_0/',
  },
  {
    version: '12.7.0',
    date: '（2024-07-15）',
    desc: '新增手机模式移动引擎功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v12_7/',
  },
  {
    version: '12.6.0',
    date: '（2024-06-14）',
    desc: '新增AI助手智能解读功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v12_6/?type=site',
  },
  {
    version: '12.5.0',
    date: '（2024-04-30）',
    desc: '新增阅读模式和小云盘功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v12_5/',
  },
  {
    version: '12.4.0',
    date: '（2024-03-26）',
    desc: '优化标签页和多窗口功能',
    title: '更新要点',
    content: [
      '1、网页密码保存流程优化：提示保存更及时、密码查看更便捷',
      '2、多窗口能力优化：增加当前标签选中态和退出按钮',
      '3、横竖版切换按钮位置更换',
      '4、登录后账号头像增加wx/qq标识',
      '5、标签页预览小窗出现时机优化减少延迟',
      '6、修复标签页预览小窗名称展示不全的问题',
      '7、修复更多功能点击后点击态一直不消失的问题',
      '8、修复新标签地址栏复制链接后不跳转的问题',
    ],
  },
  {
    version: '12.3.0',
    date: '（2024-02-24）',
    desc: '新增文件阵地快速管理文件',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v12_3/',
  },
  {
    version: '12.2.0',
    date: '（2024-01-04）',
    desc: '新增分屏及多窗口功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v3/',
  },
  {
    version: '12.1.0',
    date: '（2023-11-17）',
    desc: '新增手动自动标签分组',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v2/',
  },
  {
    version: '12.0.0',
    date: '（2023-08-14）',
    desc: '全新竖版工作台上线啦！',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide/',
  },
  ],
  MacContext: [{
    version: '21.9.0',
    date: '（2026-09-10）',
    desc: '截图搭载问AI，图片内容即刻问',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_9_0/index.html?type=site'
  },{
    version: '21.8.0',
    date: '（2026-09-01）',
    desc: '标签页PC端互通，云同步更易找',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_8_0/index.html?type=site'
  },{
    version: '21.7.0',
    date: '（2026-08-13）',
    desc: '图片查看器重磅上线，AI全能修图',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_7_0/index.html?type=site'
  },{
    version: '21.6.0',
    date: '（2026-08-03）',
    desc: 'AI助手支持多轮对话，更智能更高效',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_6_0/index.html?type=site'
  },{
    version: '21.5.0',
    date: '（2026-07-15）',
    desc: '元宝助手右键，支持收起为功能按钮',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_5_0/index.html?type=site'
  },{
    version: '21.3.0',
    date: '（2026-06-17）',
    desc: '滚动截图上新，长图整页一键尽收',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_3_0/index.html?type=site'
  },{
    version: '21.2.0',
    date: '（2026-06-08）',
    desc: '开口即搜索，语音转文字一步到位',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_2_0/index.html?type=site'
  },
    {
    version: '21.1.5',
    date: '（2026-05-13）',
    desc: '个人中心升级，支持修改头像与昵称',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_1_5/index.html?type=site'
  },{
    version: '21.1.0',
    date: '（2026-04-20）',
    desc: '138内核代际跨越，安全防护升级',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_1_0/index.html?type=site'
  },{
    version: '21.0.5',
    date: '（2026-03-26）',
    desc: '菜单新增云盘，容量一目了然',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v21_0_5/index.html?type=site'
  },{
    version: '20.1.5',
    date: '（2026-02-17）',
    desc: 'AI生PPT，文件直引一键生成',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v20_1_5/index.html?type=site',
  },{
    version: '20.1.0',
    date: '（2026-01-29）',
    desc: 'AI新首页，学习办公新起点',
    link: 'https://quickstart.imtt.qq.com/qb/din/qb/mac_guide_v20_1/index.html?type=site',
  },{
    version: '20.0.0',
    date: '（2026-01-05）',
    desc: '画中画焕新，全能窗口随心控',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v20_0/?type=site',
  },{
    version: '19.9.0',
    date: '（2025-12-05）',
    desc: '万能打开升级，支持更多格式',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_9/?type=site',
  },{
    version: '19.8.5',
    date: '（2025-11-19）',
    desc: '新增AI听，双模式随心控',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_8_5/?type=site',
  },{
    version: '19.8.0',
    date: '（2025-11-05）',
    desc: 'AI+上线，全能AI助手',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_8/?type=site',
  },{
    version: '19.7.5',
    date: '（2025-10-17）',
    desc: '「较真AI」打造事实',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_7_5/?type=site',
  },
  {
    version: '19.7.0',
    date: '（2025-9-30）',
    desc: '标签页智能分组',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_7/?type=site',
  }, {
    version: '19.6.0',
    date: '（2025-9-08）',
    desc: '智能整理,标签页管理更合心意',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_6/?type=site',
  }, {
    version: '19.5.5',
    date: '（2025-8-08）',
    desc: '书签栏按钮文案及状态优化',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_5_5/?type=site',
  },
  {
    version: '19.4.5',
    date: '（2025-7-15）',
    desc: 'AI字幕，让声音即刻“显形”',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_4_5/?type=site',
  },
  {
    version: '19.4.0',
    date: '（2025-7-03）',
    desc: 'AI探索支持创建、收藏指令',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_4/?type=site',
  },
  {
    version: '19.3.5',
    date: '（2025-6-24）',
    desc: 'QBot对话支持全屏',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_3_5/?type=site',
  },
  {
    version: '19.3.0',
    date: '（2025-5-30）',
    desc: 'AI指令一键调用',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_3/?type=site',
  }, {
    version: '19.2.5',
    date: '（2025-05-26）',
    desc: '新增相似网页推荐功能',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_2_5/?type=site',
  }, {
    version: '19.2.0',
    date: '（2025-05-18）',
    desc: '常用书签实时同步',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_2/?type=site',
  }, {
    version: '19.1.3',
    date: '（2025-04-30）',
    desc: '脑图体验优化',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_1_3/?type=site',
  }, {
    version: '19.1.2',
    date: '（2025-04-23）',
    desc: '新增阅读工具箱',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_1_2/?type=site',
  }, {
    version: '19.1.1',
    date: '（2025-04-18）',
    desc: '网页解读支持切换DeepSeek模型',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_1_1/?type=site',
  }, {
    version: '19.1.0',
    date: '（2025-04-17）',
    desc: '地址栏搜索引擎随心切换',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_1/?type=site',
  },
  {
    version: '19.0.1',
    date: '（2025-04-07）',
    desc: '优化体验和性能',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_0_1/',
  },
  {
    version: '19.0.0',
    date: '（2025-03-28）',
    desc: '全新上线QQ浏览器·QBot',
    link: 'https://quickstart.imtt.qq.com/mobile/mac_guide_v19_0/?type=site',
  }],
};
